import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import './ReceiptPage.css';
import ReceiptView from '../components/ReceiptView';

const QuotePage = () => {
    const { public_id } = useParams();
    const { i18n, t } = useTranslation();
    const { language, changeLanguage } = i18n;
    const location = useLocation();

    const [quote, setQuote] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchQuote = async () => {
            try {
                const response = await api.get(`/public/quotes/${public_id}`);
                setQuote(response.data);
            } catch (err) {
                setError(t('quotesPage.notFound'));
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchQuote();
    }, [public_id, t]);

    // Auto-print si viene con ?print=true
    useEffect(() => {
        if (!loading && quote) {
            const queryParams = new URLSearchParams(location.search);
            if (queryParams.get('print') === 'true') {
                setTimeout(() => {
                    window.print();
                }, 500);
            }
        }
    }, [loading, quote, location.search]);

    // Sincronizar idioma con el del negocio
    useEffect(() => {
        const targetLang = quote?.business_language;
        if (targetLang && language !== targetLang) {
            changeLanguage(targetLang);
        }
    }, [quote, language, changeLanguage]);

    if (loading) {
        return <div className="receipt-wrapper"><Spinner animation="border" /></div>;
    }

    if (error) {
        return <div className="receipt-wrapper"><Alert variant="danger">{error}</Alert></div>;
    }

    if (!quote) {
        return null;
    }

    return (
        <div className="receipt-wrapper">
            <ReceiptView sale={quote} documentType="quote" />
        </div>
    );
};

export default QuotePage;
